export function mapStatus(status: string) {
  const statusMap: Record<string, { label: string; color: string; borderColor: string; bgColor: string }> = {
    NEW: {
      label: "Baru",
      color: "blue-lp-700",
      borderColor: "blue-lp-700",
      bgColor: "blue-lp-600"
    },
    WORKING: {
      label: "Dalam proses",
      color: "yellow-lp-500",
      borderColor: "yellow-lp-500",
      bgColor: "yellow-lp-400"
    },
    ESCALATED: {
      label: "Dalam eskalasi",
      color: "purple-lp-900",
      borderColor: "purple-lp-800",
      bgColor: "purple-lp-100"
    },
    SOLVED: {
      label: "Sudah direspon",
      color: "aqua-lp-500",
      borderColor: "aqua-lp-500",
      bgColor: "aqua-lp-200"
    },
    "ON HOLD": {
      label: "Ditunda sementara",
      color: "gray-lp-300",
      borderColor: "gray-lp-300",
      bgColor: "gray-lp-200"
    },
    CLOSE: {
      label: "Ditutup",
      color: "chocolate-lp-100",
      borderColor: "chocolate-lp-400",
      bgColor: "chocolate-lp-200"
    },
    CLOSED: {
      label: "Ditutup",
      color: "chocolate-lp-100",
      borderColor: "chocolate-lp-400",
      bgColor: "chocolate-lp-200"
    },
    RESOLVED: {
      label: "Selesai",
      color: "green-lp-400",
      borderColor: "green-lp-400",
      bgColor: "green-lp-300"
    },
    "DOCUMENT REQUIRED": {
      label: "Menunggu dokumen",
      color: "gray-lp-1000",
      borderColor: "gray-lp-600",
      bgColor: "gray-lp-300"
    },
    "DOCUMENT RECEIVED": {
      label: "Dokumen diterima",
      color: "gray-lp-1000",
      borderColor: "gray-lp-600",
      bgColor: "black-lp-300"
    },
    INVESTIGATION: {
      label: "Dalam investigasi",
      color: "gray-lp-1000",
      borderColor: "gray-lp-600",
      bgColor: "black-lp-300"
    },
    INSURANCE: {
      label: "Diproses asuransi",
      color: "pink-lp-600",
      borderColor: "pink-lp-300",
      bgColor: "pink-lp-500"
    },
    "CUSTOMER CONFIRMATION": {
      label: "Konfirmasi customer",
      color: "gray-lp-1000",
      borderColor: "gray-lp-600",
      bgColor: "gray-lp-300"
    },
    PAID: {
      label: "Dibayar",
      color: "gray-lp-1000",
      borderColor: "gray-lp-600",
      bgColor: "black-lp-300"
    },
    REJECT: {
      label: "Ditolak",
      color: "gray-lp-1000",
      borderColor: "gray-lp-600",
      bgColor: "black-lp-300"
    },
    RECONCILE: {
      label: "Rekonsiliasi",
      color: "gray-lp-1000",
      borderColor: "gray-lp-600",
      bgColor: "black-lp-300"
    }
  };

  return statusMap[status] || {
    label: "status tidak dikenal",
    color: "text-gray-400",
    borderColor: "text-gray-400",
    bgColor: "text-gray-100"
  };
}

const styles = {
  high: {
    color: "text-red-lp-100",
    bgColor: "bg-red-lp-600"
  },
  normal: {
    color: "text-gray-lp-300",
    bgColor: "bg-gray-lp-2500"
  }
};

export function mappingListPriority(priority: string) {
  const priorityMap: Record<string, { label: string; color: string; bgColor: string }> = {
    // High priority items (red style)
    "HARD COMPLAINT": { ...styles.high, label: "#HardComplaint" },
    AGREGATOR: { ...styles.high, label: "#Agregator" },
    MARKETPLACE: { ...styles.high, label: "#Marketplace" },
    "POS DIAMOND": { ...styles.high, label: "#POS Diamond" },
    "POS PLATINUM": { ...styles.high, label: "#POS Platinum" },
    "CUST PLATINUM": { ...styles.high, label: "#Cust Platinum" },

    // Normal priority items (gray style)
    "CUST SILVER": { ...styles.normal, label: "#Cust Silver" },
    "POS GOLD": { ...styles.normal, label: "#POS Gold" },
    "POS SILVER": { ...styles.normal, label: "#POS Silver" },
    "POS BRONZE": { ...styles.normal, label: "#POS Bronze" },
    "CUST BRONZE": { ...styles.normal, label: "#Cust Bronze" },
    "CUST GOLD": { ...styles.normal, label: "#Cust Gold" },
    CORPORATE: { ...styles.normal, label: "#Corporate" }
  };

  return priorityMap[priority] || {
    ...styles.normal,
    label: "#OTHER"
  };
}

export const lastTicketStatus = ["SOLVED", "CLOSED"]